<template>
	<div :class="filterClass" class="filter table-filter--checkboxes">
		<dl class="filter__summary">
			<dt class="filter__summary__label" v-html="filterData.label"/>
			<dd v-if="filterValue" class="filter__summary__value" v-html="displayValue"/>
		</dl>
		<button v-if="filterValue" class="filter__clear" @click.prevent="clear()"><span>Clear filter</span>
		</button>
		<v-contextual-content ref="options" class="filter__options">
			<template v-slot:trigger="{ toggle }">
				<button v-if="!filterValue" class="filter__summary__set" @click.prevent="toggle()">
					<span>Show filter options</span></button>
				<button v-else class="filter__summary__clear" @click.prevent="toggle()"><span>Hide filter options</span>
				</button>
			</template>
			<h1 class="beta-up heavy">Filter by meta data</h1>
			<fieldset v-for="(data, index) in form.data.metaKeys" :key="index" class="mt-2">
				<label><span class="sr-only">Meta key</span>
					<select v-model="form.data.metaKeys[index].key">
						<option disabled selected value="">—</option>
						<option
							v-for="(key, keyIndex) in availableMetaKeys(form.data.metaKeys[index].key)"
							:key="keyIndex"
							:value="key.key" v-html="key.key"/>
					</select>
				</label>
				<label v-if="metaKey(index)"><span class="sr-only">Meta key value</span>
					<input v-if="!metaKey(index).values" v-model="form.data.metaKeys[index].value" type="text">
					<select v-else v-model="form.data.metaKeys[index].value" class="mt-1">
						<option disabled selected value="">—</option>
						<option
							v-for="(value, valueIndex) in metaKey(index).values" :key="valueIndex" :value="value"
							v-html="value"/>
					</select>
				</label>
			</fieldset>
			<ul class="actions actions--small-margin actions--vertical">
				<li v-if="canAddMetaKey">
					<button
						class="button button--secondary button--small button--wide"
						@click.prevent="addMeta()">Add A Meta Key
					</button>
				</li>
				<li>
					<button
						class="button button--primary button--small button--wide" @click.prevent="apply()">Apply
					</button>
				</li>
				<li v-if="filterValue">
					<button
						class="button button--secondary button--small button--wide"
						@click.prevent="clear()">Clear filter
					</button>
				</li>
			</ul>
		</v-contextual-content>
	</div>
</template>
<script>
export default {
	data() {
		return {
			appliedKeyIds: [],
			numberOfMetaKeys: 1,
			form: this.newForm({
				metaKeys: [{
					key: "",
					value: "",
				}],
			}),
			filterValue: null,
		};
	},

	computed: {
		filterClass() {
			return {
				"filter--has-filter": !!this.filterValue,
			};
		},
		canAddMetaKey() {
			console.log();
			return Object.keys(this.form.data.metaKeys).length < this.selectedMetaKeys.length;
		},
		selectedMetaKeys() {
			let keys = _.mapValues(this.form.data.metaKeys, data => {
				return data.key;
			});
			keys = _.filter(keys);
			return _.filter(this.filter.values, (metaKey) => {
				return keys.indexOf(metaKey.key) > -1;
			});
		},
		displayValue() {
			if (!this.filterValue) {
				return null;
			}
			return "test";
		},
	},

	props: {
		filter: {
			required: true,
			type: Function,
		},
		filterData: {
			required: true,
			type: Object,
		},
	},

	methods: {
		addMeta() {
			this.form.setInstances("metaKeys", Object.keys(this.form.data.metaKeys).length + 1);
		},
		availableMetaKeys(key) {
			return _.filter(this.data, metaKey => {
				if (metaKey.key !== key) {
					return !_.find(this.selectedMetaKeys, ["id", metaKey.id]);
				}
				return true;
			});
		},
		metaKey(index) {
			return _.find(this.data, ["key", this.form.data.metaKeys[index]?.key]);
		},
		apply() {
			this.filterValue = this.form.data.metaKeys;
			this.refs.options.toggle();
			this.filter("meta", this.filterValue);
		},
		clear() {
			this.filterValue = null;
			this.form.reset();
			this.filter("meta", this.filterValue);
		},
	},

	created() {
		this.form.setInstances("metaKeys", 1);
	},
};
</script>
